import { Text } from '@grupoboticario/flora-react'
import { useMemo } from 'react'
import useBreakpoint from '../hooks/useBreakpoint'

import '../styles/stepper.css'

type TProps = {
  steps: TStep[]
  vertical?: boolean | null
  allPainted?: boolean | null
}

const Stepper = ({ steps, vertical = null, allPainted = null }: TProps) => {
  const { isMobile } = useBreakpoint()

  const orientation = useMemo(() => {
    if (!!vertical) return 'vertical'

    return !!isMobile ? 'vertical' : 'horizontal'
  }, [isMobile])

  const getIcon = ({ Icon, className }: TStep) => {
    if (!Icon) return <></>

    return <Icon className={`stepper__icon ${className}`} />
  }

  const painted = !!allPainted ? 'all-painted' : ''

  return (
    <ul className={`stepper ${orientation} ${painted}`}>
      {steps.map((step: TStep, index: number) => (
        <li key={index} className={`stepper__item ${step.className || ''}`}>
          {getIcon(step)}
          <span className="stepper__content">
            <Text className="stepper__title">{step.title}</Text>
            <Text className="stepper__desc">{step.description}</Text>
          </span>
        </li>
      ))}
    </ul>
  )
}

export default Stepper
